import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kve-customer-relations',
  templateUrl: './customer-relations.component.html',
  styleUrls: ['./customer-relations.component.scss']
})
export class CustomerRelationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
